exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-0ac006de] .v--modal {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: transparent;\n}\n[data-v-0ac006de] .v--modal-box {\n  top: 0 !important;\n  box-shadow: none !important;\n}\n.v--modal-overlay[data-v-0ac006de] {\n  z-index: 40;\n  background-color: rgba(0, 0, 0, 0.5);\n}\n", ""]);

// exports
